export default __webpack_public_path__ + "static/media/041-mobile.1e69aa19.svg";